/*
    Redirect the user to corresponding checkout page according to their status
 */
define('shared/initializer/checkout/redirector',[
    'shared/lib/RSVP',
    'shared/lib/URI',
    'shared/util/state',
    'shared/util/hub',
    'shared/page/wcmmode',
    'shared/page/runmode',
    'shared/util/state/adapters/order',
    'shared/util/state/adapters/user',
    'shared/util/state/adapters/persistent',
    'shared/remote/member/get',
    'shared/remote/efid/const',
    'shared/initializer/form/constants',
    'shared/util/checkout/member',
    'shared/util/checkout/checkout',
    'shared/my/identity',
    'shared/my/efid',
    'shared/page/apiVersion',
    '$'
], 
function ( 
    RSVP, 
    URI, 
    state, 
    hub, 
    getWCMMode, 
    getRunMode,
    orderAdapter, 
    userAdapter, 
    persistentAdapter,
    getMember, 
    efidConsts,
    constants, 
    memberUtil,
    checkoutUtil,
    getIdentity,
    efid,
    getAPIVersion,
    $
) {
    'use strict';

    var HUB = '/checkout/redirector/finished';
    var DEBUG_KEY = 'persistent.debugger_checkout_redirect_disabled';
    var uri = new URI(window.location.href);
    var path = uri.path(true);
    var abort = {};
    var udef;

    var sitePrefix = getNonTldPrefix();

    var defaultSteps = [
        {name: 'member', path: sitePrefix + '/buy/default/member/', isDefault: true},
        {name: 'payment', path: sitePrefix + '/buy/default/payment/', isDefault: true},
        {name: 'thankyou', path: sitePrefix + '/buy/default/thankyou/', isDefault: true}];

    function getStep( steps, name ) {
        var step;

        for( var i = 0; i < steps.length; i++ ) {
            if ( steps[i].name == name ) {
                step = steps[i];
                break;
            }
        }

        return step;
    }

    function getRedirectPromise() {
        var err = new Error('Redirecting...');
        err.type = 'redirect';
        return RSVP.reject(err);
    }

    function escapeHTML(s) {
        return s.split('&').join('&amp;').split('<').join('&lt;').split('"').join('&quot;');
    }

    //http://stackoverflow.com/questions/470832/getting-an-absolute-url-from-a-relative-one-ie6-issue
    function getAbsPath(url) {
        var el= document.createElement('div');
        el.innerHTML= '<a href="'+escapeHTML(url)+'">x</a>';
        var uri = new URI(el.firstChild.href);
        return uri.path(true);
    }

    function redirectToFlow(flowName, targetPageName){
        var uri = new URI(window.location.href);
        var query = uri.query();
        var sitePrefix = getNonTldPrefix();

        if(query){
            window.location.href = sitePrefix + '/buy/' + flowName + '/' + targetPageName + '/?' + query;
        }
        else{
            window.location.href = sitePrefix + '/buy/' + flowName + '/' + targetPageName + '/';
        }
    }

    function redirectToLogin(){
        var sitePrefix = getNonTldPrefix();
        var loginUri = new URI(sitePrefix + '/login/');
        loginUri.addSearch('returnurl', window.location.pathname + window.location.search);
        window.location.href = loginUri.toString();
    }

    function getNonTldPrefix(){
        var nonTldMatch = window.location.pathname.match(/^(\/\w\w-\w\w\w?)\/.*/);
        if(nonTldMatch){
            return nonTldMatch[1];
        }
        else{
            return null;
        }
    }

    function createError(type, message){
        var err = new Error(message);
        err.type = type;
        hub.set(HUB, true);
        return err;
    }

    function mergeDefaultSteps(originalSteps, defaultSteps){
        for(var i = 0; i < defaultSteps.length; i++){
            var currentDefaultStep = defaultSteps[i];
            var stepAlreadyExists = false;
            for(var j = 0; j < originalSteps.length; j++){
                if(originalSteps[j].name === currentDefaultStep.name){
                    stepAlreadyExists = true;
                    break;
                }
            }

            if(!stepAlreadyExists){
                originalSteps.push(currentDefaultStep);
            }
        }
    }

    function isMemberExistsForCurrentUser() {
        return getAPIVersion()
            .then(function(api){
                if (api === 'new-house') {
                    return getMember()
                        .then(function(json){
                            if (json == null) {
                                return false;
                            }
                            else {
                                return true;
                            }
                        });
                }
                else {
                    return getIdentity()
                        .then(function(memberID){
                            if (memberID != null && memberID != '') {
                                return true;
                            }
                            else {
                                return false;
                            }
                        });
                }
            });
    }

    function getIDForCurrentUser() {
        return getAPIVersion()
            .then(function(api){
                if (api === 'new-house') {
                    return efid.get();
                }
                else {
                    return getIdentity();
                }
            });
    }

    function oldHouseRedirection(
        memberExist,
        stateValues,
        userID,
        flowType,
        memberStep,
        paymentStep,
        thankyouStep
    ) {
        var offerIds = Array.isArray(stateValues[0])?stateValues[0]:[stateValues[0]];
        var orderId = stateValues[1];        

        if(flowType == constants.CheckoutFlowType.WelcomeBack){
            return RSVP.resolve();
        }

        if (memberExist == false) {
            if (
                flowType === constants.CheckoutFlowType.Default
            ) {
                if (memberStep == null) {
                    return RSVP.reject(createError(null, 'Cannot find member page info.'));
                }

                if (!memberStep.isDefault && getAbsPath(path) !== getAbsPath(memberStep.path)) {
                    window.location.href = memberStep.path + '?' + uri.query();
                    return getRedirectPromise();
                }

                return RSVP.resolve();
            } else if (
                flowType === constants.CheckoutFlowType.Return || 
                flowType === constants.CheckoutFlowType.Upsell ||
                flowType === constants.CheckoutFlowType.PaymentUpdate
            ) {
                redirectToLogin();
                return getRedirectPromise();
            } 

            return RSVP.resolve();
        }

        return getMember().then(function(member){
            var err;
            if(!member){
                return RSVP.reject(createError(null, 'Cannot get member for userID: ' + userID));
            }

            if (memberUtil.isUpdatingMemberInfo()) {
                return RSVP.resolve();
            }

            if (flowType == constants.CheckoutFlowType.PaymentUpdate){
                return RSVP.resolve();
            }

            switch(member.StudentType){
                case constants.StudentType.CurrentStudent:
                    if (thankyouStep && getAbsPath(path) === getAbsPath(thankyouStep.path) ) {
                        return RSVP.resolve();
                    }

                    if(flowType == constants.CheckoutFlowType.Default){
                        if(member.HasRenewableActiveSubscription){
                            redirectToFlow(constants.CheckoutDefaultFlowName.Return, 'payment');
                        }else{
                            return RSVP.reject(createError('currentStudent', 'CurrentStudent - our record shows you are currently a student and cannot buy an extra subscription.'));
                        }
                    }
                    else if(flowType == constants.CheckoutFlowType.Return){
                        if(!member.HasRenewableActiveSubscription){
                            return RSVP.reject(createError('currentStudent', 'CurrentStudent - our record shows you are currently a student and cannot buy an extra subscription.'));
                        }
                    }
                    else if(flowType == constants.CheckoutFlowType.Upsell){
                        return RSVP.resolve();
                    }
                    break;
                case constants.StudentType.LapsedStudent:
                    if(flowType == constants.CheckoutFlowType.Return){
                        if(member.HasSuspendedSubscription){
                            return RSVP.reject(createError('suspendedStudent', 'Suspended Subscription - You are already a student during your suspension period! If you want to resume your initial account, contact us please.'));
                        }
                    }
                    else{
                        redirectToFlow(constants.CheckoutDefaultFlowName.Return, 'payment');
                        return getRedirectPromise();
                    }
                    break;
                case udef:
                case constants.StudentType.NeverStudent:
                    if(flowType != constants.CheckoutFlowType.Default){
                        redirectToFlow(constants.CheckoutDefaultFlowName.Default, 'payment');
                        return getRedirectPromise();
                    }
                    break;
                default:
                    return RSVP.reject(createError(null, 'Not supported student type: ' + member.StudentType));
            }

            if (memberStep &&
                getAbsPath(path) === getAbsPath(memberStep.path) &&
                memberUtil.isUpdatingMemberInfo()) {
                return RSVP.resolve();
            }

            if (
                offerIds.length <= 0 || 
                !!offerIds[0] || 
                orderId == null || 
                orderId === ''
            ) {

                if (paymentStep == null) {
                    err = new Error('Cannot find paymentStep page info.');
                    return RSVP.reject(err);
                }

                if (getAbsPath(path) !== getAbsPath(paymentStep.path)) {
                    window.location.href = paymentStep.path + '?' + uri.query();
                    return getRedirectPromise();
                }
            }
            else {
                if (thankyouStep == null) {
                    err = new Error('Cannot find thankyouStep page info.');
                    return RSVP.reject(err);
                }

                if (getAbsPath(path) !== getAbsPath(thankyouStep.path)) {
                    window.location.href = thankyouStep.path + '?' + uri.query();
                    return getRedirectPromise();
                }
            }

            return RSVP.resolve();
        });
    }

    function waitForRedirectDestination(url) {
        return new RSVP.Promise(function(rs, rj){
            function always(func) {
                return function () {
                    var ctxt = this;
                    var args = arguments;

                    window.removeEventListener('message', handler);
                    $(iframe).remove();

                    return func.apply(ctxt, args);
                };
            }

            var iframe = document.createElement('iframe');
            iframe.style.display = 'none';
            iframe.src = url;

            var handler = getWindowMessageHandler(always(rs), always(rj));
            window.addEventListener('message', handler);

            $('body').append(iframe);
        });
    }

    function getWindowMessageHandler(resolve, reject) {
        return function(evt) {
            if (typeof evt.data !== 'object') {
                return;
            }

            if (evt.data.type !== 'default.redirect.destination') {
                return;
            }

            if (evt.data.destination != null) {
                resolve(evt.data.destination);
            }
            else {
                reject('Destination cannot be found');
            }
        };
    }

    function newHouseRedirection(
        memberExist,
        stateValues,
        userID,
        flowType,
        memberStep,
        paymentStep,
        thankyouStep
    ) {
        if (flowType === constants.CheckoutFlowType.WelcomeBack) {
            return RSVP.resolve();
        }

        return waitForRedirectDestination(efidConsts.RETRIEVE_DESTINATION)
            .then(function(destination){
                if (
                    (
                        memberStep && getAbsPath(path) === getAbsPath(memberStep.path) && 
                        (
                            (
                                flowType !== constants.CheckoutFlowType.Redemption &&
                                destination.name !== 'member' &&
                                destination.name !== 'login'
                            )
                        ) 
                    ) ||
                    (
                        paymentStep && getAbsPath(path) === getAbsPath(paymentStep.path) && 
                        destination.name !== 'payment' && 
                        (
                            (
                                flowType !== constants.CheckoutFlowType.Return &&
                                flowType !== constants.CheckoutFlowType.Upsell
                            ) ||
                            (
                                flowType === constants.CheckoutFlowType.Return && 
                                destination.hasActiveAccount
                            ) ||
                            (
                                flowType === constants.CheckoutFlowType.Upsell &&
                                !destination.hasActiveAccount
                            )
                        )
                    ) ||
                    (thankyouStep && getAbsPath(path) === getAbsPath(thankyouStep.path) && 
                        (
                            destination.name !== 'enrollment' &&
                            destination.name !== 'my-page'
                        )
                    )
                ) {
                    console.log('redirecting to:', destination.name, destination.url, destination.hasActiveAccount);
                    location.href = destination.url;
                    return getRedirectPromise();
                }
            });
    }

    function redirect(options){
        var flowType;
        var prm = RSVP.resolve()
        .then(function(){
            return checkoutUtil.getCurrentFlowType();
        })
        .then(function(type){
            flowType = type;
            return RSVP.all([state.adapters.add(persistentAdapter)]);
        })
        .then(function() {
            hub
                .get('/debuglet/settings')
                .then(function(settings){
                    settings['Disable Redirection'] = {
                        getValue: function() {
                            return new RSVP.Promise(function(resolve) {
                                if ( state == null ) {
                                    resolve(false);
                                }
                                else {
                                    state
                                        .get(DEBUG_KEY)
                                        .then(function(values){
                                            resolve(values[0] && values[0].value || false);
                                        });
                                }
                            });
                        },
                        setValue: function(value) {
                            return new RSVP.Promise(function(resolve) {
                                if ( state == null ) {
                                    resolve();
                                }
                                else {
                                    state
                                        .push(DEBUG_KEY, {value: value})
                                        .then(function(){
                                            resolve();
                                        });
                                }
                            });
                        }
                    };
                });
        })
        .then(function(){
            return RSVP.all([
                getWCMMode(), 
                state.get(DEBUG_KEY), 
                state.adapters.add(orderAdapter),
                state.adapters.add(userAdapter)
            ]);
        })
        .then(function(values){
            var wcmmode = values[0];
            var debuggerDisabled = values[1] && values[1][0] && values[1][0].value;

            if ( wcmmode !== 'disabled' || debuggerDisabled === true ) {
                // do nothing if we are editing or designing
                return RSVP.resolve(abort);
            }
            
            return getAPIVersion();

        })
        .then(function(apiVersion){
            if (apiVersion === abort) {
                return;
            }
            
            var handler;

            if (apiVersion === 'new-house') {
                handler = newHouseRedirection;
            }
            else {
                handler = oldHouseRedirection;
            }

            var steps = ( options && options.steps ) || defaultSteps;
            mergeDefaultSteps(steps, defaultSteps);

            var memberStep = getStep(steps, 'member');
            var paymentStep = getStep(steps, 'payment');
            var thankyouStep = getStep(steps, 'thankyou');

            return RSVP.all([
                isMemberExistsForCurrentUser(), 
                state.get(constants.State.OrderOfferId, 'order.order_id'), 
                getIDForCurrentUser(),
                RSVP.resolve(flowType),
                RSVP.resolve(memberStep),
                RSVP.resolve(paymentStep),
                RSVP.resolve(thankyouStep)
            ])
            .then(function(values){
                if (values === abort) {
                    return RSVP.resolve();
                }
                return handler.apply(this, values);
            });
        });

        return prm.then(function(){ 
            hub.set(HUB, true);
        });
    }

    return {
        redirect: function() {
            var me = this;
            var args = Array.prototype.slice.apply(arguments);
            return RSVP.resolve()
                .then(function(){
                    return getRunMode();
                })
                .then(function(runMode){
                    if (runMode==='author') {
                        return;
                    }
                    return redirect.apply(me, args);
                });
        }
    };
});
